const Townhouse: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 57 58',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0th)">
      <path
        d="M54.8735 14.6319H1.77007C1.28063 14.6319 0.88501 14.2363 0.88501 13.7469C0.88501 13.2574 1.28063 12.8618 1.77007 12.8618H54.8735C55.363 12.8618 55.7586 13.2574 55.7586 13.7469C55.7586 14.2363 55.363 14.6319 54.8735 14.6319Z"
        fill={fill}
      />
      <path
        d="M54.8735 17.2872H1.77007C1.28063 17.2872 0.88501 16.8916 0.88501 16.4021C0.88501 15.9127 1.28063 15.5171 1.77007 15.5171H54.8735C55.363 15.5171 55.7586 15.9127 55.7586 16.4021C55.7586 16.8916 55.363 17.2872 54.8735 17.2872Z"
        fill={fill}
      />
      <path
        d="M1.77003 14.6323C1.67798 14.6323 1.58328 14.6172 1.49035 14.5862C1.02746 14.4322 0.776109 13.9313 0.930994 13.4666L3.58617 5.50113C3.74105 5.03824 4.23668 4.78689 4.70488 4.94266C5.16776 5.09666 5.41912 5.5976 5.26424 6.06225L2.60906 14.0278C2.48604 14.3977 2.14087 14.6323 1.77003 14.6323Z"
        fill={fill}
      />
      <path
        d="M54.8735 14.6322C54.5027 14.6322 54.1575 14.3976 54.0345 14.0268L51.3793 6.06127C51.2244 5.5975 51.4749 5.09567 51.9387 4.94167C52.4069 4.7859 52.9034 5.03726 53.0583 5.50103L55.7135 13.4665C55.8683 13.9303 55.6179 14.4321 55.1541 14.5861C55.0603 14.6171 54.9656 14.6322 54.8735 14.6322Z"
        fill={fill}
      />
      <path
        d="M24.2126 6.6666H4.42534C3.9359 6.6666 3.54028 6.27098 3.54028 5.78154C3.54028 5.29211 3.9359 4.89648 4.42534 4.89648H24.2126C24.702 4.89648 25.0976 5.29211 25.0976 5.78154C25.0976 6.27098 24.702 6.6666 24.2126 6.6666Z"
        fill={fill}
      />
      <path
        d="M16.8161 14.6321C16.6002 14.6321 16.3842 14.5533 16.2134 14.3949C15.8558 14.063 15.8346 13.5028 16.1674 13.1443L27.674 0.753523C28.005 0.395075 28.567 0.374719 28.9246 0.7075C29.2822 1.0394 29.3034 1.59964 28.9706 1.95809L17.464 14.3489C17.2905 14.5374 17.0542 14.6321 16.8161 14.6321Z"
        fill={fill}
      />
      <path
        d="M39.8275 14.632C39.5894 14.632 39.3531 14.5373 39.1797 14.3497L27.6748 1.95889C27.342 1.60044 27.3624 1.0402 27.7208 0.708304C28.0775 0.375522 28.6386 0.394994 28.9714 0.754327L40.4763 13.1451C40.809 13.5036 40.7887 14.0638 40.4302 14.3957C40.2594 14.5533 40.0435 14.632 39.8275 14.632Z"
        fill={fill}
      />
      <path
        d="M52.2183 6.6666H32.4319C31.9425 6.6666 31.5469 6.27098 31.5469 5.78154C31.5469 5.29211 31.9425 4.89648 32.4319 4.89648H52.2183C52.7077 4.89648 53.1033 5.29211 53.1033 5.78154C53.1033 6.27098 52.7077 6.6666 52.2183 6.6666Z"
        fill={fill}
      />
      <path
        d="M4.42534 57.1148C3.9359 57.1148 3.54028 56.7192 3.54028 56.2297V16.4021C3.54028 15.9127 3.9359 15.5171 4.42534 15.5171C4.91478 15.5171 5.3104 15.9127 5.3104 16.4021V56.2297C5.3104 56.7192 4.91478 57.1148 4.42534 57.1148Z"
        fill={fill}
      />
      <path
        d="M52.2193 57.1148C51.7298 57.1148 51.3342 56.7192 51.3342 56.2297V16.4021C51.3342 15.9127 51.7298 15.5171 52.2193 15.5171C52.7087 15.5171 53.1043 15.9127 53.1043 16.4021V56.2297C53.1043 56.7192 52.7087 57.1148 52.2193 57.1148Z"
        fill={fill}
      />
      <path
        d="M54.8735 57.1148H1.77007C1.28063 57.1148 0.88501 56.7192 0.88501 56.2298C0.88501 55.7403 1.28063 55.3447 1.77007 55.3447H54.8735C55.363 55.3447 55.7586 55.7403 55.7586 56.2298C55.7586 56.7192 55.363 57.1148 54.8735 57.1148Z"
        fill={fill}
      />
      <path
        d="M18.5862 34.1035C18.0968 34.1035 17.7012 33.7079 17.7012 33.2184V22.5978H10.6207V33.2184C10.6207 33.7079 10.2251 34.1035 9.73564 34.1035C9.24621 34.1035 8.85059 33.7079 8.85059 33.2184V21.7127C8.85059 21.2233 9.24621 20.8276 9.73564 20.8276H18.5862C19.0757 20.8276 19.4713 21.2233 19.4713 21.7127V33.2184C19.4713 33.7079 19.0757 34.1035 18.5862 34.1035Z"
        fill={fill}
      />
      <path
        d="M19.4713 34.1036H8.85063C8.3612 34.1036 7.96558 33.708 7.96558 33.2186C7.96558 32.7291 8.3612 32.3335 8.85063 32.3335H19.4713C19.9608 32.3335 20.3564 32.7291 20.3564 33.2186C20.3564 33.708 19.9608 34.1036 19.4713 34.1036Z"
        fill={fill}
      />
      <path
        d="M32.7471 34.1035C32.2577 34.1035 31.862 33.7079 31.862 33.2184V22.5978H24.7816V33.2184C24.7816 33.7079 24.386 34.1035 23.8965 34.1035C23.4071 34.1035 23.0115 33.7079 23.0115 33.2184V21.7127C23.0115 21.2233 23.4071 20.8276 23.8965 20.8276H32.7471C33.2365 20.8276 33.6322 21.2233 33.6322 21.7127V33.2184C33.6322 33.7079 33.2365 34.1035 32.7471 34.1035Z"
        fill={fill}
      />
      <path
        d="M32.7471 57.1148C32.2577 57.1148 31.862 56.7192 31.862 56.2298V39.4137H24.7816V56.2298C24.7816 56.7192 24.386 57.1148 23.8965 57.1148C23.4071 57.1148 23.0115 56.7192 23.0115 56.2298V38.5286C23.0115 38.0392 23.4071 37.6436 23.8965 37.6436H32.7471C33.2365 37.6436 33.6322 38.0392 33.6322 38.5286V56.2298C33.6322 56.7192 33.2365 57.1148 32.7471 57.1148Z"
        fill={fill}
      />
      <path
        d="M33.6322 34.1036H23.0115C22.5221 34.1036 22.1265 33.708 22.1265 33.2186C22.1265 32.7291 22.5221 32.3335 23.0115 32.3335H33.6322C34.1216 32.3335 34.5173 32.7291 34.5173 33.2186C34.5173 33.708 34.1216 34.1036 33.6322 34.1036Z"
        fill={fill}
      />
      <path
        d="M46.908 34.1035C46.4186 34.1035 46.0229 33.7079 46.0229 33.2184V22.5978H38.9425V33.2184C38.9425 33.7079 38.5469 34.1035 38.0574 34.1035C37.568 34.1035 37.1724 33.7079 37.1724 33.2184V21.7127C37.1724 21.2233 37.568 20.8276 38.0574 20.8276H46.908C47.3974 20.8276 47.7931 21.2233 47.7931 21.7127V33.2184C47.7931 33.7079 47.3974 34.1035 46.908 34.1035Z"
        fill={fill}
      />
      <path
        d="M47.7931 34.1036H37.1724C36.683 34.1036 36.2874 33.708 36.2874 33.2186C36.2874 32.7291 36.683 32.3335 37.1724 32.3335H47.7931C48.2825 32.3335 48.6782 32.7291 48.6782 33.2186C48.6782 33.708 48.2825 34.1036 47.7931 34.1036Z"
        fill={fill}
      />
      <path
        d="M18.5862 50.9194C18.0968 50.9194 17.7012 50.5238 17.7012 50.0344V39.4137H10.6207V50.0344C10.6207 50.5238 10.2251 50.9194 9.73564 50.9194C9.24621 50.9194 8.85059 50.5238 8.85059 50.0344V38.5286C8.85059 38.0392 9.24621 37.6436 9.73564 37.6436H18.5862C19.0757 37.6436 19.4713 38.0392 19.4713 38.5286V50.0344C19.4713 50.5238 19.0757 50.9194 18.5862 50.9194Z"
        fill={fill}
      />
      <path
        d="M19.4713 50.9195H8.85063C8.3612 50.9195 7.96558 50.5239 7.96558 50.0345C7.96558 49.545 8.3612 49.1494 8.85063 49.1494H19.4713C19.9608 49.1494 20.3564 49.545 20.3564 50.0345C20.3564 50.5239 19.9608 50.9195 19.4713 50.9195Z"
        fill={fill}
      />
      <path
        d="M46.908 50.9194C46.4186 50.9194 46.0229 50.5238 46.0229 50.0344V39.4137H38.9425V50.0344C38.9425 50.5238 38.5469 50.9194 38.0574 50.9194C37.568 50.9194 37.1724 50.5238 37.1724 50.0344V38.5286C37.1724 38.0392 37.568 37.6436 38.0574 37.6436H46.908C47.3974 37.6436 47.7931 38.0392 47.7931 38.5286V50.0344C47.7931 50.5238 47.3974 50.9194 46.908 50.9194Z"
        fill={fill}
      />
      <path
        d="M47.7931 50.9195H37.1724C36.683 50.9195 36.2874 50.5239 36.2874 50.0345C36.2874 49.545 36.683 49.1494 37.1724 49.1494H47.7931C48.2825 49.1494 48.6782 49.545 48.6782 50.0345C48.6782 50.5239 48.2825 50.9195 47.7931 50.9195Z"
        fill={fill}
      />
      <path
        d="M1.77007 17.2871C1.28063 17.2871 0.88501 16.8915 0.88501 16.402V13.7469C0.88501 13.2574 1.28063 12.8618 1.77007 12.8618C2.2595 12.8618 2.65512 13.2574 2.65512 13.7469V16.402C2.65512 16.8915 2.2595 17.2871 1.77007 17.2871Z"
        fill={fill}
      />
      <path
        d="M54.8736 17.2871C54.3841 17.2871 53.9885 16.8915 53.9885 16.402V13.7469C53.9885 13.2574 54.3841 12.8618 54.8736 12.8618C55.363 12.8618 55.7586 13.2574 55.7586 13.7469V16.402C55.7586 16.8915 55.363 17.2871 54.8736 17.2871Z"
        fill={fill}
      />
      <path
        d="M49.5633 9.32187H39.3223C38.8329 9.32187 38.4373 8.92625 38.4373 8.43682C38.4373 7.94738 38.8329 7.55176 39.3223 7.55176H49.5633C50.0527 7.55176 50.4484 7.94738 50.4484 8.43682C50.4484 8.92625 50.0527 9.32187 49.5633 9.32187Z"
        fill={fill}
      />
      <path
        d="M50.4482 11.9771H41.7879C41.2985 11.9771 40.9028 11.5815 40.9028 11.0921C40.9028 10.6027 41.2985 10.207 41.7879 10.207H50.4482C50.9376 10.207 51.3332 10.6027 51.3332 11.0921C51.3332 11.5815 50.9376 11.9771 50.4482 11.9771Z"
        fill={fill}
      />
      <path
        d="M17.3223 9.32187H7.08037C6.59093 9.32187 6.19531 8.92625 6.19531 8.43682C6.19531 7.94738 6.59093 7.55176 7.08037 7.55176H17.3223C17.8117 7.55176 18.2073 7.94738 18.2073 8.43682C18.2073 8.92625 17.8117 9.32187 17.3223 9.32187Z"
        fill={fill}
      />
      <path
        d="M14.8565 11.9771H6.19536C5.70592 11.9771 5.3103 11.5815 5.3103 11.0921C5.3103 10.6027 5.70592 10.207 6.19536 10.207H14.8565C15.346 10.207 15.7416 10.6027 15.7416 11.0921C15.7416 11.5815 15.346 11.9771 14.8565 11.9771Z"
        fill={fill}
      />
      <path
        d="M14.1609 27.9081C13.6715 27.9081 13.2759 27.5125 13.2759 27.023V21.7127C13.2759 21.2233 13.6715 20.8276 14.1609 20.8276C14.6504 20.8276 15.046 21.2233 15.046 21.7127V27.023C15.046 27.5125 14.6504 27.9081 14.1609 27.9081Z"
        fill={fill}
      />
      <path
        d="M11.5057 30.5635C11.0162 30.5635 10.6206 30.1679 10.6206 29.6784C10.6206 29.189 11.0162 28.7934 11.5057 28.7934C12.4819 28.7934 13.2758 27.9995 13.2758 27.0232C13.2758 26.5338 13.6714 26.1382 14.1608 26.1382C14.6503 26.1382 15.0459 26.5338 15.0459 27.0232C15.0459 28.9757 13.4581 30.5635 11.5057 30.5635Z"
        fill={fill}
      />
      <path
        d="M11.5058 30.5636H9.73564C9.24621 30.5636 8.85059 30.168 8.85059 29.6785C8.85059 29.1891 9.24621 28.7935 9.73564 28.7935H11.5058C11.9952 28.7935 12.3908 29.1891 12.3908 29.6785C12.3908 30.168 11.9952 30.5636 11.5058 30.5636Z"
        fill={fill}
      />
      <path
        d="M12.3909 34.1035C11.9015 34.1035 11.5059 33.7079 11.5059 33.2184V29.5242C11.5059 29.0348 11.9015 28.6392 12.3909 28.6392C12.8804 28.6392 13.276 29.0348 13.276 29.5242V33.2184C13.276 33.7079 12.8804 34.1035 12.3909 34.1035Z"
        fill={fill}
      />
      <path
        d="M16.8161 30.5635C14.8637 30.5635 13.2759 28.9757 13.2759 27.0232C13.2759 26.5338 13.6715 26.1382 14.1609 26.1382C14.6504 26.1382 15.046 26.5338 15.046 27.0232C15.046 27.9995 15.8399 28.7934 16.8161 28.7934C17.3055 28.7934 17.7012 29.189 17.7012 29.6784C17.7012 30.1679 17.3055 30.5635 16.8161 30.5635Z"
        fill={fill}
      />
      <path
        d="M18.5863 30.5636H16.8162C16.3268 30.5636 15.9312 30.168 15.9312 29.6785C15.9312 29.1891 16.3268 28.7935 16.8162 28.7935H18.5863C19.0758 28.7935 19.4714 29.1891 19.4714 29.6785C19.4714 30.168 19.0758 30.5636 18.5863 30.5636Z"
        fill={fill}
      />
      <path
        d="M15.931 34.1035C15.4415 34.1035 15.0459 33.7079 15.0459 33.2184V29.5242C15.0459 29.0348 15.4415 28.6392 15.931 28.6392C16.4204 28.6392 16.816 29.0348 16.816 29.5242V33.2184C16.816 33.7079 16.4204 34.1035 15.931 34.1035Z"
        fill={fill}
      />
      <path
        d="M28.3228 27.9081C27.8334 27.9081 27.4377 27.5125 27.4377 27.023V21.7127C27.4377 21.2233 27.8334 20.8276 28.3228 20.8276C28.8122 20.8276 29.2079 21.2233 29.2079 21.7127V27.023C29.2079 27.5125 28.8122 27.9081 28.3228 27.9081Z"
        fill={fill}
      />
      <path
        d="M25.6675 30.5635C25.1781 30.5635 24.7825 30.1679 24.7825 29.6784C24.7825 29.189 25.1781 28.7934 25.6675 28.7934C26.6437 28.7934 27.4376 27.9995 27.4376 27.0232C27.4376 26.5338 27.8333 26.1382 28.3227 26.1382C28.8121 26.1382 29.2078 26.5338 29.2078 27.0232C29.2078 28.9757 27.62 30.5635 25.6675 30.5635Z"
        fill={fill}
      />
      <path
        d="M25.6676 30.5636H23.8975C23.4081 30.5636 23.0125 30.168 23.0125 29.6785C23.0125 29.1891 23.4081 28.7935 23.8975 28.7935H25.6676C26.1571 28.7935 26.5527 29.1891 26.5527 29.6785C26.5527 30.168 26.1571 30.5636 25.6676 30.5636Z"
        fill={fill}
      />
      <path
        d="M26.5528 34.1035C26.0633 34.1035 25.6677 33.7079 25.6677 33.2184V29.5242C25.6677 29.0348 26.0633 28.6392 26.5528 28.6392C27.0422 28.6392 27.4378 29.0348 27.4378 29.5242V33.2184C27.4378 33.7079 27.0422 34.1035 26.5528 34.1035Z"
        fill={fill}
      />
      <path
        d="M30.978 30.5635C29.0255 30.5635 27.4377 28.9757 27.4377 27.0232C27.4377 26.5338 27.8334 26.1382 28.3228 26.1382C28.8122 26.1382 29.2079 26.5338 29.2079 27.0232C29.2079 27.9995 30.0018 28.7934 30.978 28.7934C31.4674 28.7934 31.863 29.189 31.863 29.6784C31.863 30.1679 31.4674 30.5635 30.978 30.5635Z"
        fill={fill}
      />
      <path
        d="M32.7482 30.5636H30.9781C30.4886 30.5636 30.093 30.168 30.093 29.6785C30.093 29.1891 30.4886 28.7935 30.9781 28.7935H32.7482C33.2376 28.7935 33.6332 29.1891 33.6332 29.6785C33.6332 30.168 33.2376 30.5636 32.7482 30.5636Z"
        fill={fill}
      />
      <path
        d="M30.0928 34.1035C29.6034 34.1035 29.2078 33.7079 29.2078 33.2184V29.5242C29.2078 29.0348 29.6034 28.6392 30.0928 28.6392C30.5823 28.6392 30.9779 29.0348 30.9779 29.5242V33.2184C30.9779 33.7079 30.5823 34.1035 30.0928 34.1035Z"
        fill={fill}
      />
      <path
        d="M42.4844 27.9081C41.995 27.9081 41.5994 27.5125 41.5994 27.023V21.7127C41.5994 21.2233 41.995 20.8276 42.4844 20.8276C42.9739 20.8276 43.3695 21.2233 43.3695 21.7127V27.023C43.3695 27.5125 42.9739 27.9081 42.4844 27.9081Z"
        fill={fill}
      />
      <path
        d="M39.8291 30.5635C39.3397 30.5635 38.9441 30.1679 38.9441 29.6784C38.9441 29.189 39.3397 28.7934 39.8291 28.7934C40.8054 28.7934 41.5993 27.9995 41.5993 27.0232C41.5993 26.5338 41.9949 26.1382 42.4843 26.1382C42.9738 26.1382 43.3694 26.5338 43.3694 27.0232C43.3694 28.9757 41.7816 30.5635 39.8291 30.5635Z"
        fill={fill}
      />
      <path
        d="M39.8292 30.5636H38.0591C37.5697 30.5636 37.1741 30.168 37.1741 29.6785C37.1741 29.1891 37.5697 28.7935 38.0591 28.7935H39.8292C40.3187 28.7935 40.7143 29.1891 40.7143 29.6785C40.7143 30.168 40.3187 30.5636 39.8292 30.5636Z"
        fill={fill}
      />
      <path
        d="M40.7144 34.1035C40.225 34.1035 39.8293 33.7079 39.8293 33.2184V29.5242C39.8293 29.0348 40.225 28.6392 40.7144 28.6392C41.2038 28.6392 41.5995 29.0348 41.5995 29.5242V33.2184C41.5995 33.7079 41.2038 34.1035 40.7144 34.1035Z"
        fill={fill}
      />
      <path
        d="M45.1396 30.5635C43.1872 30.5635 41.5994 28.9757 41.5994 27.0232C41.5994 26.5338 41.995 26.1382 42.4844 26.1382C42.9739 26.1382 43.3695 26.5338 43.3695 27.0232C43.3695 27.9995 44.1634 28.7934 45.1396 28.7934C45.629 28.7934 46.0247 29.189 46.0247 29.6784C46.0247 30.1679 45.629 30.5635 45.1396 30.5635Z"
        fill={fill}
      />
      <path
        d="M46.9098 30.5636H45.1397C44.6503 30.5636 44.2546 30.168 44.2546 29.6785C44.2546 29.1891 44.6503 28.7935 45.1397 28.7935H46.9098C47.3992 28.7935 47.7949 29.1891 47.7949 29.6785C47.7949 30.168 47.3992 30.5636 46.9098 30.5636Z"
        fill={fill}
      />
      <path
        d="M44.2544 34.1035C43.765 34.1035 43.3694 33.7079 43.3694 33.2184V29.5242C43.3694 29.0348 43.765 28.6392 44.2544 28.6392C44.7439 28.6392 45.1395 29.0348 45.1395 29.5242V33.2184C45.1395 33.7079 44.7439 34.1035 44.2544 34.1035Z"
        fill={fill}
      />
      <path
        d="M14.1609 44.724C13.6715 44.724 13.2759 44.3284 13.2759 43.839V38.5286C13.2759 38.0392 13.6715 37.6436 14.1609 37.6436C14.6504 37.6436 15.046 38.0392 15.046 38.5286V43.839C15.046 44.3284 14.6504 44.724 14.1609 44.724Z"
        fill={fill}
      />
      <path
        d="M11.5057 47.3794C11.0162 47.3794 10.6206 46.9838 10.6206 46.4943C10.6206 46.0049 11.0162 45.6093 11.5057 45.6093C12.4819 45.6093 13.2758 44.8154 13.2758 43.8392C13.2758 43.3497 13.6714 42.9541 14.1608 42.9541C14.6503 42.9541 15.0459 43.3497 15.0459 43.8392C15.0459 45.7916 13.4581 47.3794 11.5057 47.3794Z"
        fill={fill}
      />
      <path
        d="M11.5058 47.3795H9.73564C9.24621 47.3795 8.85059 46.9839 8.85059 46.4944C8.85059 46.005 9.24621 45.6094 9.73564 45.6094H11.5058C11.9952 45.6094 12.3908 46.005 12.3908 46.4944C12.3908 46.9839 11.9952 47.3795 11.5058 47.3795Z"
        fill={fill}
      />
      <path
        d="M12.3909 50.9194C11.9015 50.9194 11.5059 50.5238 11.5059 50.0344V46.3401C11.5059 45.8507 11.9015 45.4551 12.3909 45.4551C12.8804 45.4551 13.276 45.8507 13.276 46.3401V50.0344C13.276 50.5238 12.8804 50.9194 12.3909 50.9194Z"
        fill={fill}
      />
      <path
        d="M16.8161 47.3794C14.8637 47.3794 13.2759 45.7916 13.2759 43.8392C13.2759 43.3497 13.6715 42.9541 14.1609 42.9541C14.6504 42.9541 15.046 43.3497 15.046 43.8392C15.046 44.8154 15.8399 45.6093 16.8161 45.6093C17.3055 45.6093 17.7012 46.0049 17.7012 46.4943C17.7012 46.9838 17.3055 47.3794 16.8161 47.3794Z"
        fill={fill}
      />
      <path
        d="M18.5863 47.3795H16.8162C16.3268 47.3795 15.9312 46.9839 15.9312 46.4944C15.9312 46.005 16.3268 45.6094 16.8162 45.6094H18.5863C19.0758 45.6094 19.4714 46.005 19.4714 46.4944C19.4714 46.9839 19.0758 47.3795 18.5863 47.3795Z"
        fill={fill}
      />
      <path
        d="M15.931 50.9194C15.4415 50.9194 15.0459 50.5238 15.0459 50.0344V46.3401C15.0459 45.8507 15.4415 45.4551 15.931 45.4551C16.4204 45.4551 16.816 45.8507 16.816 46.3401V50.0344C16.816 50.5238 16.4204 50.9194 15.931 50.9194Z"
        fill={fill}
      />
      <path
        d="M42.4844 44.724C41.995 44.724 41.5994 44.3284 41.5994 43.839V38.5286C41.5994 38.0392 41.995 37.6436 42.4844 37.6436C42.9739 37.6436 43.3695 38.0392 43.3695 38.5286V43.839C43.3695 44.3284 42.9739 44.724 42.4844 44.724Z"
        fill={fill}
      />
      <path
        d="M39.8291 47.3794C39.3397 47.3794 38.9441 46.9838 38.9441 46.4943C38.9441 46.0049 39.3397 45.6093 39.8291 45.6093C40.8054 45.6093 41.5993 44.8154 41.5993 43.8392C41.5993 43.3497 41.9949 42.9541 42.4843 42.9541C42.9738 42.9541 43.3694 43.3497 43.3694 43.8392C43.3694 45.7916 41.7816 47.3794 39.8291 47.3794Z"
        fill={fill}
      />
      <path
        d="M39.8292 47.3795H38.0591C37.5697 47.3795 37.1741 46.9839 37.1741 46.4944C37.1741 46.005 37.5697 45.6094 38.0591 45.6094H39.8292C40.3187 45.6094 40.7143 46.005 40.7143 46.4944C40.7143 46.9839 40.3187 47.3795 39.8292 47.3795Z"
        fill={fill}
      />
      <path
        d="M40.7144 50.9194C40.225 50.9194 39.8293 50.5238 39.8293 50.0344V46.3401C39.8293 45.8507 40.225 45.4551 40.7144 45.4551C41.2038 45.4551 41.5995 45.8507 41.5995 46.3401V50.0344C41.5995 50.5238 41.2038 50.9194 40.7144 50.9194Z"
        fill={fill}
      />
      <path
        d="M45.1396 47.3794C43.1872 47.3794 41.5994 45.7916 41.5994 43.8392C41.5994 43.3497 41.995 42.9541 42.4844 42.9541C42.9739 42.9541 43.3695 43.3497 43.3695 43.8392C43.3695 44.8154 44.1634 45.6093 45.1396 45.6093C45.629 45.6093 46.0247 46.0049 46.0247 46.4943C46.0247 46.9838 45.629 47.3794 45.1396 47.3794Z"
        fill={fill}
      />
      <path
        d="M46.9098 47.3795H45.1397C44.6503 47.3795 44.2546 46.9839 44.2546 46.4944C44.2546 46.005 44.6503 45.6094 45.1397 45.6094H46.9098C47.3992 45.6094 47.7949 46.005 47.7949 46.4944C47.7949 46.9839 47.3992 47.3795 46.9098 47.3795Z"
        fill={fill}
      />
      <path
        d="M44.2544 50.9194C43.765 50.9194 43.3694 50.5238 43.3694 50.0344V46.3401C43.3694 45.8507 43.765 45.4551 44.2544 45.4551C44.7439 45.4551 45.1395 45.8507 45.1395 46.3401V50.0344C45.1395 50.5238 44.7439 50.9194 44.2544 50.9194Z"
        fill={fill}
      />
      <path
        d="M26.5516 49.1491C26.0621 49.1491 25.6665 48.7535 25.6665 48.2641V46.4939C25.6665 46.0045 26.0621 45.6089 26.5516 45.6089C27.041 45.6089 27.4366 46.0045 27.4366 46.4939V48.2641C27.4366 48.7535 27.041 49.1491 26.5516 49.1491Z"
        fill={fill}
      />
      <path
        d="M21.6474 14.6302C21.4315 14.6302 21.2155 14.5514 21.0447 14.393C20.6871 14.0602 20.6659 13.5 20.9987 13.1424L27.6738 5.95662C28.0066 5.59905 28.5686 5.57958 28.9244 5.91059C29.2819 6.24337 29.3032 6.80362 28.9704 7.16118L22.2953 14.347C22.1218 14.5355 21.8855 14.6302 21.6474 14.6302Z"
        fill={fill}
      />
      <path
        d="M34.997 14.6303C34.7589 14.6303 34.5235 14.5356 34.3492 14.348L27.6741 7.16219C27.3413 6.80462 27.3616 6.24438 27.7201 5.9116C28.0768 5.57882 28.6379 5.59918 28.9707 5.95762L35.6458 13.1434C35.9785 13.501 35.9582 14.0612 35.5997 14.394C35.4289 14.5515 35.213 14.6303 34.997 14.6303Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0th">
        <rect
          y="0.471191"
          width="56.6437"
          height="56.6437"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

export default Townhouse
